import useSWR from 'swr';
import { API_BASE_URL } from '../lib/constants';
import useBoundStore from '../store';

const useNotificationGeneralFilterLimit = () => {
  const token = useBoundStore.getState().authToken;

  const fetcher = (url: string) =>
    fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }).then((res) => res.json());

  const { data } = useSWR(`${API_BASE_URL}facilities/filter-general-limits`, fetcher);

  return data;
};

export default useNotificationGeneralFilterLimit;
